const actions = {
  set: 'SET::REMEMBER_ME'
}

export const setRememberMe = rememberMe => ({ type: actions.set, keepLoggedIn: rememberMe })

export default actions
